import BlogFortyFiveContainer from "./container/BlogFortyFiveContainer";
export default BlogFortyFiveContainer;
